import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'belong',
      type: 'select',
      label: '归属模块',
      placeholder: '请选择归属模块',
      options: [],
      clearable: true
    },
    {
      field: 'code',
      type: 'select',
      label: '股票代码',
      placeholder: '填写或搜索股票代码或名称',
      filterable: true,
      options: [],
      clearable: true
    },
    {
      field: 'date',
      type: 'datepicker',
      label: '荐股日期',
      clearable: false,
      otherOptions: {
        startPlaceholder: '起始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
